const showPasswordButtons = document.querySelectorAll<HTMLButtonElement>(".show-password-btn");

for (const showPasswordButton of showPasswordButtons) {
    showPasswordButton?.addEventListener("click", (event: MouseEvent) => {
        const currentTarget = event.currentTarget as HTMLButtonElement;
        const passwordInput = currentTarget.previousElementSibling as HTMLInputElement;
        passwordInput.type = passwordInput.type == "text" ? "password" : "text";
    });
}
